import { render, staticRenderFns } from "./listpay.vue?vue&type=template&id=95476032&scoped=true"
import script from "./listpay.vue?vue&type=script&lang=js"
export * from "./listpay.vue?vue&type=script&lang=js"
import style0 from "./listpay.vue?vue&type=style&index=0&id=95476032&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95476032",
  null
  
)

export default component.exports